import DataLoader from 'dataloader'
import type { AgentsEnablementApi } from '@/features/relation-manager/api/agents-enablement-api'
import { Id } from '@/infra/id'

/**
 * Checks whether agents are enabled per workspace.
 */
export class AgentsEnablementStore {
  private readonly _loader = new DataLoader<string, boolean>(
    this._fetchManyCore.bind(this),
  )

  constructor(private readonly _api: AgentsEnablementApi) {}

  async fetch(workspaceId: Id) {
    return await this._loader.load(Id.assert(workspaceId))
  }

  private async _fetchManyCore(workspaceIds: readonly string[]) {
    return await Promise.all(
      workspaceIds.map((id) => this._api.getStatus(id).then((r) => r.enabled)),
    )
  }
}
